module.exports = __webpack_public_path__ + "eb45f26f2d5ebe2d46997f7adbce78ee.png";